export default "__VITE_ASSET__vOA_ggww__"